import React, {
    useEffect,
    useRef,
    useState,
    useContext,
    useMemo,
    memo,
} from 'react';

import { EqualHeightContext } from './equal-height-context';

import styles from './equal-height.module.scss';


const EqualHeightElement = memo((props) => {
    const {
        children = '',
        name,
        tag = 'div',
        placeholder = false,
        disable = false,
        className = ''
    } = props;

    const {
        sizes,
        update,
        setTemporarySizes,
        setOriginalChildrenCount,
        setChildrenCount,
        animationSpeed
    } = useContext(EqualHeightContext);

    const [height, setHeight] = useState();

    const innerElement = useRef(null);

    // Calculate method
    const getHeight = () => {
        if (!innerElement.current || disable) {return;}
        const tempHeight = innerElement.current.style.getPropertyValue('height');
        innerElement.current.style.removeProperty('height');
        const newHeight = innerElement.current.offsetHeight;
        innerElement.current.style.setProperty('height', tempHeight);
        setTemporarySizes(values => {
            return [...values, {
                name,
                height: newHeight
            }]
        });

        if (!disable) {
            setChildrenCount(value => value + 1);
        }
    };

    // Init
    useEffect(() => {
        if (disable) {return;}

        setOriginalChildrenCount(value => value + 1);
        return () => {
            setOriginalChildrenCount(value => value - 1);
        };
    }, [disable, placeholder]);


    useEffect(() => {
        if (disable) {return;}

        getHeight();
    }, [update, disable, placeholder]);


    useMemo(() => {
        if (disable) {return;}

        const elementIndex = sizes.findIndex((e) => e.name === name);

        if (sizes && sizes[elementIndex] && sizes[elementIndex].height) {
            setHeight(sizes[elementIndex].height);
        }
    }, [sizes]);


    const inlineStyles = {
        height: `${height}px`,
        transitionDuration: animationSpeed === 0 ? '' : `${animationSpeed}s`
    };

    if (!placeholder && !children) {
        return null;
    }

    return (
        <>
            { disable ? (
                children
            ) : (
                React.createElement(tag, {
                    ref: innerElement,
                    className: `${styles.wrapper} ${className}`,
                    style: inlineStyles
                }, !placeholder && children)
            )}
        </>
    );
});

export default EqualHeightElement;
